// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__2y-Td","label":"Radio_label__1xwFP","checkMark":"Radio_checkMark__1KwRI","disabled":"Radio_disabled__3R8CE"};